import { Interface } from '../../../../../FrontendBundle/Resources/js/ofcs';

/**
 * The canvas is the foundation object of all drawable objects. It provides
 * an API for the editor for drawing operations and the view objects.
 *
 * This is the interface definition of the canvas classes.
 *
 * @interface CanvasInterface
 */
export default new Interface({
    /**
     * Must contain an DOM element of the canvas representation
     */
    element: {},

    /**
     * Should display the rotate handle on the canvas
     */
    showRotateHandle() {},

    /**
     * Should hide the rotate handle on the canvas
     */
    hideRotateHandle() {},

    /**
     * Register callbacks.
     */
    on() {},

    /**
     * Get item selection.
     */
    getSelection() {},

    /**
     * Returns current foam instance
     */
    getFoam() {},

    /**
     * Returns view collection
     */
    getViewCollection() {},
});
